// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section-module--wrapper--2E8or","innerWrapper":"section-module--innerWrapper--2vSkE","narrow":"section-module--narrow--3SajO"};